import {useCallback, useRef} from 'react';

export const useBulkActionDialog = (close: () => void) => {
    const pending = useRef(false);
    const onPendingChange = useCallback((value: boolean) => {
        pending.current = value;
    }, []);
    const onClose = useCallback(() => {
        if (!pending.current) {
            close();
        }
    }, [close]);

    return {onClose, onPendingChange};
};
